import type { Result } from '../types/result';

export const tryCatch = <T>(fn: () => T, finallyFn?: () => void): Result<T> => {
    try {
        const data = fn();
        return { success: true, data };
    } catch (error) {
        return { success: false, error };
    } finally {
        finallyFn?.();
    }
};

export const tryCatchAsync = async <T>(
    fn: () => Promise<T>,
    finallyFn?: () => void
): Promise<Result<T>> => {
    try {
        const data = await fn();
        return { success: true, data };
    } catch (error) {
        return { success: false, error };
    } finally {
        finallyFn?.();
    }
};
